/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

export async function fetchMoreObjects(apollo, variables) {
  let result;
  let error;

  try {
    result = await apollo.queries.objects.fetchMore({
      variables,
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const newEdges = fetchMoreResult.objects.edges;

        return {
          objects: {
            pageInfo: fetchMoreResult.objects.pageInfo,
            edges: [...previousResult.objects.edges, ...newEdges],
            __typename: previousResult.objects.__typename,
          },
        };
      },
    });
  } catch (err) {
    error = err;
  }

  return { result, error };
}
